/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DetailProposalPolicyPage = lazyLoad(
  () => import('./index'),
  module => module.DetailProposalPolicyPage
);
